import BasicVert from "raw-loader!../../Shaders/basic-vert.glsl";
import ScreenVert from "raw-loader!../../Shaders/screen-vert.glsl";
export default {
    "basic-vert": BasicVert,
    "screen-vert": ScreenVert,
};



// WEBPACK FOOTER //
// ./src/Material/Defaults/DefaultStaticImport.ts